import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const ProtectedRoute = ({ children, onUserUpdate }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Check authentication status whenever route changes
    const checkAuth = async () => {
      try {
        const response = await axios.get('/api/auth/current-user/', {
          withCredentials: true,
        });
        const user = response.data.user;
        const authenticated = user !== null;
        setIsAuthenticated(authenticated);
        // Update user state in parent component
        if (onUserUpdate) {
          onUserUpdate(user);
        }
      } catch (err) {
        setIsAuthenticated(false);
        if (onUserUpdate) {
          onUserUpdate(null);
        }
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
